/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import StatesService from '../../../Service/StatesService';
import { toastError, toastOnTenantCreated } from '../../../SweetAlertUtil/util';
import Loader from '../../../Component/Common/Loader';
import PageHeader from '../../Common/PageHeader';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';

const AppConfig = window.AppConfig;
const REGULAR_EXPRESSION = AppConfig.REGULAR_EXPRESSION;
let countries = [];
function StateSpecificInterestRateForm(props) {
	const { handleSubmit, register, errors } = useForm();
	const onSubmit = async (values, e) => {
		try {
			setLoader(true);
			const requestBody = {
				name: values.name,
				shortName: values.shortName,
				max_interest_rate: null,
				short_term: parseFloat(values.shortTerm),
				mid_term: 0,
				long_term: 0,
				recommended_rate: parseFloat(values.recommendedRate),
				recommended_max_rate: parseFloat(values.recommendedMaxRate),
				true_max_rate: null,
				if_loan_is: null,
				tenant_id: props.match.params.id,
				country_id: values.countryId
			};
			if (
				requestBody.short_term < 0 ||
				requestBody.recommended_rate < 0 ||
				requestBody.recommended_rate > 100 ||
				requestBody.recommended_max_rate > 100
			) {
				toastError('Check the input fields again');
			} else if (
				requestBody.short_term <= requestBody.recommended_rate &&
				requestBody.recommended_rate <= requestBody.recommended_max_rate
			) {
				requestBody.short_name = values.shortName.toLowerCase();
				const response = await StatesService.create(requestBody);
				if (response.status) {
					document.getElementById('create-state-form').reset();
					const successMsg = `Region has been successfully created.`;
					toastOnTenantCreated(successMsg, () => {
						e.target.reset();
						props.history.push('/admin/tenant/states/' + props.match.params.id);
					});
				} else {
					toastError(response.data);
				}
			} else {
				toastError('Check the input fields again');
			}
			setLoader(false);
		} catch (error) {
			setLoader(false);
		}
	};

	const [isLoading, setLoader] = useState(false);
	useEffect(() => {
		(async () => {
			setLoader(true);
			const response = await StatesService.getCountries();
			countries = response;
			setLoader(false);
		})();
	}, []);

	return (
		<>
			<PageHeader />
			<section className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="card card-primary">
								<div className="card-header">
									<h3 className="card-title" style={{ marginLeft: '40%' }}>
										Add A Region
									</h3>
								</div>
								<form
									onSubmit={handleSubmit(onSubmit)}
									id="create-state-form"
									// role="form"
								>
									<div className="card-body">
										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputEmail1">Country Name</label>
													<div className="input-group">
														<select
															aria-hidden="true"
															className="form-control select2 select2-hidden-accessible"
															data-select2-id="1"
															defaultValue=""
															name="countryId"
															ref={register}
															style={{ width: '100%' }}
															tabIndex="-1">
															{countries !== null
																? countries.map((option, index) => (
																		<option
																			data-select2-id="0"
																			key={index}
																			selected="selected"
																			value={option.id}>
																			{option.name}
																		</option>
																  ))
																: ''}
														</select>
													</div>
													{errors.countryId && <p className="error">Country is required.</p>}
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputEmail1">Region Name</label>
													<input
														className="form-control"
														defaultValue=""
														id="exampleInputEmail1"
														name="name"
														placeholder="Enter Region Name"
														ref={register({
															required: true
														})}
														type="string"
													/>
													{errors.name && <p className="error">Region Name is required.</p>}
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputPassword1">Short Name</label>
													<input
														className="form-control"
														defaultValue=""
														id="exampleInputPassword1"
														name="shortName"
														placeholder="Enter Short Name"
														ref={register({
															required: {
																value: true,
																message: 'Short Name is required.'
															},
															pattern: {
																value: REGULAR_EXPRESSION.SHORT_NAME,
																message:
																	'Short Name cannot have space or any special character'
															}
														})}
														type="string"
													/>
													{errors.shortName && (
														<p className="error">{errors.shortName.message}</p>
													)}
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputPassword1">Min Interest</label>
													<div className="input-group mb-3">
														<div className="input-group-prepend">
															<span className="input-group-text">%</span>
														</div>
														<input
															className="form-control"
															defaultValue=""
															name="shortTerm"
															placeholder="Enter Short Term"
															ref={register({
																required: 'Min Interest is required.'
															})}
															type="number"
														/>
													</div>
													<p className="hint">
														<span style={{ color: 'black' }}>HINT: </span>Min Interest Rate
														should either be 0 or more than 0 and less than Max Interest
														Rate
													</p>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputPassword1">Recommended Interest</label>
													<div className="input-group mb-3">
														<div className="input-group-prepend">
															<span className="input-group-text">%</span>
														</div>
														<input
															className="form-control"
															defaultValue=""
															name="recommendedRate"
															placeholder="Enter Recommended Rate"
															ref={register({
																required: 'Recommended Interest is required.'
															})}
															type="number"
														/>
													</div>
													<p className="hint">
														<span style={{ color: 'black' }}>HINT: </span>Recommended
														Interest Rate should be between Min and Max Interest Rate
													</p>
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label htmlFor="exampleInputPassword1">Max Interest</label>
													<div className="input-group mb-3">
														<div className="input-group-prepend">
															<span className="input-group-text">%</span>
														</div>
														<input
															className="form-control"
															defaultValue=""
															name="recommendedMaxRate"
															placeholder="Recommended Max Rate"
															ref={register({
																required: 'Max Interest Rate is required.'
															})}
															type="number"
														/>
													</div>
													<p className="hint">
														<span style={{ color: 'black' }}>HINT: </span>Max Interest Rate
														should either be 100 or less than 100 and more than Min Interest
														Rate
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<button className="btn btn-primary" style={{ marginLeft: '40%' }} type="submit">
											Submit
										</button>
									</div>
								</form>
							</div>
							{isLoading ? <Loader /> : ''}
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default withRouter(hot(module)(StateSpecificInterestRateForm));
